import React from 'react'
import LandingLayout from '../../layouts/landing'
import { VStack } from '@chakra-ui/react'
import AbmPanel from '../../components/abmPanel'

const Abm: React.FC = () => {
  return (
    <LandingLayout>
      <VStack>
        <AbmPanel />
      </VStack>
    </LandingLayout>
  )
}

export default Abm
